import { render, staticRenderFns } from "./FeaturesDeactivation.vue?vue&type=template&id=638fc332&scoped=true&"
import script from "./FeaturesDeactivation.vue?vue&type=script&lang=ts&"
export * from "./FeaturesDeactivation.vue?vue&type=script&lang=ts&"
import style0 from "./FeaturesDeactivation.vue?vue&type=style&index=0&id=638fc332&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "638fc332",
  null
  
)

export default component.exports